import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchSituationList } from "@/api/PMS/customerService/lostAndFound/queryList";
import waves from "@/directive/waves"; // 水波纹指令

import receiveConfirm from "./receiveConfirm";
import history from "./history";
export default {
  components: {
    receiveConfirm: receiveConfirm,
    history: history
  },
  directives: {
    waves: waves
  },
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        receiveState: ""
      },
      id: null,
      title: "",
      noticeTypeId: -1,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogHistoryVisible: false,
      dialogReceiveConfirmVisible: false
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.listQuery = {
          page: 1,
          limit: 10
        };
        this.getList();
      }
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handCancle: function handCancle(reload) {
      this.getList();

      if (reload === 3) {
        this.$emit("handCancle", 3);
      } else {
        this.dialogHistoryVisible = false;
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.goodsLostAndFoundId = this.keyValue;
      fetchSituationList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    // 领取确认
    handleReceiveConfirm: function handleReceiveConfirm(id) {
      this.id = id;
      this.title = "领取确认";
      this.dialogReceiveConfirmVisible = true;
    },
    // 查看历史确认
    handleHistory: function handleHistory(id) {
      this.id = id;
      this.title = "查看历史确认";
      this.dialogHistoryVisible = true;
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};